import { Component, Input, OnInit, inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { setSkipInteraction, shouldSkip, SkipInteraction, StoreService } from '@shared/store';

@Component({
  selector: 'app-skip-interaction-checkbox',
  templateUrl: './skip-interaction-checkbox.component.html',
  styleUrls: ['./skip-interaction-checkbox.component.scss'],
  standalone: false,
})
export class SkipInteractionCheckboxComponent implements OnInit {
  private readonly store = inject(StoreService);
  private readonly fb = inject(NonNullableFormBuilder);

  @Input() interaction: SkipInteraction | undefined = undefined;

  public readonly form = this.fb.group({
    checkbox: false,
  });
  public get checkbox() {
    return this.form.controls.checkbox;
  }

  ngOnInit(): void {
    if (!this.interaction) {
      console.warn("SkipInteractionCheckboxComponent was initialised without an interaction specified");
      return;
    }

    const initialValue = this.store.select(shouldSkip(this.interaction));
    this.checkbox.setValue(initialValue);
    this.checkbox.markAsPristine();

    this.checkbox.valueChanges.subscribe((value) => {
      this.store.dispatch(setSkipInteraction({ interaction: this.interaction, skip: value }));
    });
  }
}
